var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<md-dialog aria-label=\"Dialog Service\"><md-toolbar layout-padding=\"layout-padding\"><div class=\"md-tooolbar-tools\"><h4>{{dialogOptions.headerText}}</h4></div></md-toolbar><md-dialog-content layout-padding=\"layout-padding\"><p>{{dialogOptions.bodyText}}</p></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"dialogOptions.close('cancel')\">{{dialogOptions.closeButtonText}}</md-button><md-button ng-click=\"dialogOptions.ok('ok')\">{{dialogOptions.actionButtonText}}</md-button></md-dialog-actions></md-dialog>");;return buf.join("");
}

module.exports = module.exports.apply(module, [])


//////////////////
// WEBPACK FOOTER
// ./~/apply-loader!./app/common/tmDialogSvc.jade
// module id = 326
// module chunks = 0